export const setCarItems = (payload) => ({
  type: "SET_CART_ITEMS",
  payload,
});


